import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Notification } from "app/models/notification";

import * as _ from "lodash";

import { URLSearchParams } from '@angular/http';
import { HttpBackendService } from "./http-backend.service";
import { PagedResult } from "../models/PagedResult";


@Injectable()
export class NotificationService {
  constructor(
    private http: HttpBackendService
  ) { }

  public getNotifications(count: number, skip: number): Observable<PagedResult<Notification>> {

    let params = new URLSearchParams;
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");
    params.append('$orderby',"Created desc");

    return this.http.get("/api/odata/notifications", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<Notification>();

        const http = this.http;
        result.totalCount = pagedResult["@odata.count"];
        result.items = _.map(pagedResult.value, function (value) {
          return NotificationService.convertNotificationDTO2Object(http, value);
        });

        return result;
      });
  }

  public getNewNotificationsCount(): Observable<number> {
    let params = new URLSearchParams;
    params.append('$top', "0");
    params.append('$count', "true");
    params.append('$filter',"IsRead eq false");

    return this.http.get("/api/odata/notifications", params, true)
      .map(resp => {
        const result = resp.json();

        return result["@odata.count"];
      });
  }

  public confirmNotification(notificationId: number) {
    return this.http.post("/api/notification/" + notificationId+ "/read", null, null, true)
      .map(_ => { });
  }

  public confirmAllNotifications() {
    return this.http.post("/api/notification/readAll", null, null, true);
  }
}

export namespace NotificationService {
  export function convertNotificationDTO2Object(http: HttpBackendService, dto: any, notification: Notification = new Notification()): Notification {
    notification.id = dto.Id;
    notification.message = dto.Type;
    notification.created = dto.Created != null ? http.parseDate(dto.Created) : null;
    notification.isRead = dto.IsRead;

    switch (dto.Type) {
      case "NewMessage": {
        notification.message = 'По обращению ' + dto.CallNumber + ' добавлен комментарий';
        notification.link = '/call/' + dto.CallId + '/message/';
        break;
      }
      default: {
        break;
      }
    }

    return notification;
  };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/notification.service.ts